import React, { useCallback } from 'react';
import { string, bool, func, number } from 'prop-types';
import classnames from 'classnames';
import './Characteristic.scss';
import './Characteristic-images.scss';

export default function Characteristic({
    icon,
    claim,
    active,
    className,
    index,
    onHover,
}) {
    const handleUnableRedirection = useCallback(e => {
        e.stopPropagation();
        e.preventDefault();
    }, []);

    const handleHover = useCallback(
        e => {
            if (onHover) {
                onHover(e, index);
            }
        },
        [onHover],
    );

    const rootClassnames = classnames(
        'characteristic',
        {
            'characteristic--active': active,
        },
        className,
    );

    return (
        <div
            className={rootClassnames}
            onClick={handleUnableRedirection}
            onKeyPress={handleUnableRedirection}
            onMouseEnter={handleHover}
            onFocus={handleHover}
            role="button"
            tabIndex="0"
        >
            {icon === 'DeliveryPayment' && (
                <span className="characteristic__icon characteristic-images-delivery-payment" />
            )}
            {icon === 'DeliveryFree' && (
                <span className="characteristic__icon characteristic-images-delivery-free" />
            )}
            {icon === 'Delivery24h' && (
                <span className="characteristic__icon characteristic-images-delivery-24h" />
            )}
            {icon === 'Pro' && (
                <span className="characteristic__icon characteristic-images-delivery-pro" />
            )}
            {icon === 'Manomano' && (
                <span className="characteristic__icon characteristic-images-delivery-manomano" />
            )}
            <div className="characteristic__label">{claim}</div>
        </div>
    );
}

Characteristic.propTypes = {
    icon: string.isRequired,
    claim: string.isRequired,
    className: string,
    active: bool,
    index: number,
    onHover: func,
};

Characteristic.defaultProps = {
    className: null,
    active: false,
    index: 0,
    onHover: null,
};
